import { useEffect, useState } from 'react'
import { breakpoints } from '@awazevr/design-system.utils.react'

const MOBILE_QUERY = `(max-width: ${breakpoints[0] - 1}px)`

export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const mq = globalThis.matchMedia(MOBILE_QUERY)
    setIsMobile(mq.matches)

    const handleChange = (event: MediaQueryListEvent) =>
      setIsMobile(event.matches)

    mq.addEventListener('change', handleChange)
    return () => mq.removeEventListener('change', handleChange)
  }, [])

  return isMobile
}
